import { render, staticRenderFns } from "./OrgUnitNode.vue?vue&type=template&id=5d177547"
import script from "./OrgUnitNode.vue?vue&type=script&lang=js"
export * from "./OrgUnitNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports